export function Sec2Str(sec, format) {

    if (sec == 0) {
       // return "";
    }

    let predznak = "";

    if ((sec < 0)) {
        sec = (sec * -1);
        predznak = "-";
    }


    let h = Math.floor((sec / 3600));
    let m = Math.floor(((sec % 3600) / 60));
    let s = Math.floor((sec % 60));


    if (format == undefined) {
        return predznak + "" + String(h).padStart(2, '0') + ":" + String(m).padStart(2, '0') + ":" + String(s).padStart(2, '0');
    } else {
        if (format != null && format.split(":").length > 2) {
            return predznak + "" + String(h).padStart(2, '0') + ":" + String(m).padStart(2, '0') + ":" + String(s).padStart(2, '0');
        } else {
            return predznak + "" + String(h).padStart(2, '0') + ":" + String(m).padStart(2, '0');
        }
    }
}


export function Str2Sec(time, format) {
    let minus = false;

    if (time.indexOf("-") >= 0) {
        minus = true;
        time = time.replaceAll("-", "");
    }

    let timeseg = time
        .replaceAll(".", ":")
        .replaceAll(",", ":")
        .replaceAll(" ", ":")
        .split(":");
    let h = 0;
    let m = 0;
    let s = 0;
    if (timeseg.length >= 1) {
        s = parseInt(timeseg[timeseg.length - 1]);
        if (isNaN(s)) { s = 0 }
    }
    if (timeseg.length >= 2) {
        m = parseInt(timeseg[timeseg.length - 2]);
        if (isNaN(s)) { m = 0 }
    }
    if (timeseg.length >= 3) {
        h = parseInt(timeseg[timeseg.length - 3]);
        if (isNaN(s)) { h = 0 }
    }
    let sec = 0;
    if (format == undefined || (format != null && format.split(":").length > 2)) {

        if (timeseg.length == 1) sec = (s * 3600);
        else if (timeseg.length == 2) sec = (m * 3600) + (s * 60);
        else if (timeseg.length == 3) sec = (h * 3600) + (m * 60) + s;
       
    } else {
        if (timeseg.length == 1) sec = (s * 3600);
        else if (timeseg.length == 2) sec = (m * 3600) + (s * 60);
    }

    if (minus) {
        sec = -sec;
    }

    return sec;

}